module.exports = __webpack_public_path__ + "img/appBack2.a306a209.png";